import { BsImage } from 'react-icons/bs';
import { FiCheck } from 'react-icons/fi';
import {
  MdArrowRight,
  MdRemove,
  MdSubdirectoryArrowRight,
} from 'react-icons/md';
import styled from 'styled-components';

const Heading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  justify-content: flex-end;
`;

const TableContainer = styled.div`
  padding: 32px;
`;

const MainPageContainer = styled.div`
  padding: 20px 0;
`;

const PillContainer = styled.div`
  display: flex;
  align-items: center;
`;

const MultiSelectIcon = styled(FiCheck)`
  height: 24px;
  width: 24px;
  margin-left: 20px;
`;

const SubCategoryContainer = styled.div`
  display: grid;
  height: 64px;
  border-bottom: 0.5px solid #eaedf3;
`;
const SubCategory = styled.div`
  display: flex;
  align-items: center;
`;
const SubCategoryName = styled.span``;
const SubCategoryActions = styled.div``;

const OpenGroupIcon = styled(MdArrowRight)`
  rotate: 90deg;
  font-size: 24px;
  cursor: pointer;
`;

const ClosedGroupIcon = styled(MdArrowRight)`
  cursor: pointer;
  font-size: 24px;
`;

const SubCategoryIcon = styled(MdRemove)``;

const EnterIcon = styled(MdSubdirectoryArrowRight)``;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  width: min-content;
`;

const NoThumbnail = styled(BsImage)`
  color: ${({ theme }) => theme.COLOR_GREY4};
  height: 20px;
  width: 20px;
  margin: 10px;
`;

const Thumbnail = styled.img`
  color: ${({ theme }) => theme.COLOR_GREY4};
  height: 40px;
  width: 40px;
`;

const productCategoriesStyle = {
  Heading,
  MainPageContainer,
  TableContainer,
  PillContainer,
  SubCategoryContainer,
  SubCategory,
  SubCategoryName,
  SubCategoryActions,
  OpenGroupIcon,
  ClosedGroupIcon,
  SubCategoryIcon,
  EnterIcon,
  MultiSelectIcon,
  IconContainer,
  NoThumbnail,
  Thumbnail,
};

export default productCategoriesStyle;
